import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { IOrderLastSelectedState } from '~/types/order/models'

const orderLastSelectedStateListData =
  undefined as unknown as IOrderLastSelectedState[]

export const getOrderLastSelectedStateListData = getListDataFunctionFactory<
  IOrderLastSelectedState[]
>({
  listData: orderLastSelectedStateListData,
  storageKey: 'orderlastselectedstates',
  getStartingListData: getStartingOrderLastSelectedStateListData,
})

export async function getOrderLastSelectedStateData(
  id: TEntityId
): Promise<IOrderLastSelectedState> {
  const list: IOrderLastSelectedState[] =
    await getOrderLastSelectedStateListData()
  if (!list) {
    throw new Error(`getOrderLastSelectedStateData returned undefined/null`)
  }
  const orderLastSelectedState = list.find((olsd) => olsd.id === id)
  if (!orderLastSelectedState) {
    throw new Error(`Can't find orderLastSelectedState '${id}'`)
  }
  return orderLastSelectedState
}

export async function getOrderLastSelectedStateDataByOrderId(
  id: TEntityId
): Promise<IOrderLastSelectedState | undefined> {
  const list: IOrderLastSelectedState[] =
    await getOrderLastSelectedStateListData()
  if (!list) {
    throw new Error(`getOrderLastSelectedStateList returned undefined/null`)
  }
  const orderLastSelectedState = list.find((olsd) => isEqual(olsd.orderId, id))
  return orderLastSelectedState
}

export async function getStartingOrderLastSelectedStateListData(): Promise<
  IOrderLastSelectedState[]
> {
  return [
    {
      id: 'XXORDLSD0001',
      hrid: 'ORDLSD0001',
      orderId: 'XXORD0001',
      selectedMSId: 'XXORDMS0001',
      selectedMSServiceIds: undefined,
      // ⚠ WAS `selectedOrderId` until 2026-09-09. The API renamed its column to
      // `selected_order_service_order_id` in WXTG/cynque-api-server#1547, which
      // is what the webapp had always WRITTEN; only the type, the read-back and
      // this fixture carried the stale name.
      selectedOrderServiceOrderId: undefined,
      // ⚠ NO `selectedContractId` HERE, AND THAT IS NOT AN OMISSION TO FIX.
      // The Order model has no such column server-side (Company and Opportunity
      // do) — WXTG/cynque-api-server#1593. This mock's generic merge-PATCH will
      // happily store and return one anyway, so a contract picked on an Order
      // Overview SURVIVES A RELOAD LOCALLY AND IS LOST IN PRODUCTION. Measured,
      // 2026-09-09. Do not "verify" Order contract persistence against the mock
      // until that ticket lands.
      selectedScreenTopTabValue: 'Sales',
      version: '1',
      canBeDeleted: true,
    },
  ]
}
